const cleanInput = (value: string | number, allowNegative = false) => {
  let result = `${value}`.replace(/[^0-9-.]+/g, '');

  // keep first minus only
  const isNegative = result[0] === '-';
  result = result.replace(/-/g, '');
  if (isNegative && allowNegative) {
    result = `-${result}`;
  }

  if (result[0] === '.') {
    let arr = result.split('');
    arr.unshift('0');
    result = arr.join('');
  }

  // keep first dot only
  if (result.indexOf('.') !== -1) {
    const [integer, ...rest] = result.split('.');
    result = `${integer}.${rest.join('')}`;
  }

  return result;
};

interface Options {
  max?: number;
  precision?: number;
  allowNegative?: boolean;
}

export const normalize =
  ({ max = Number.MAX_VALUE, precision = 2, allowNegative = false }: Options = {}) =>
  (value: string) => {
    let cleaned = cleanInput(value, allowNegative);

    const result = +(cleaned.match(/[-.]$/) ? `${cleaned}0` : cleaned); // avoid NaN for `-` and `1.` inputs
    if (typeof max === 'number' && result > max) {
      cleaned = `${max}`;
    }

    const [, decimals] = cleaned.split('.');

    if (decimals && decimals.length > precision) {
      cleaned = cleaned.substring(0, cleaned.length - (decimals.length - precision));
    }

    return cleaned;
  };
